var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowForwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.5C13 9.30012 12.9165 9.10023 12.7374 8.94243L8.52462 5.22881C8.17852 4.92373 7.60567 4.92373 7.25957 5.22881C6.91348 5.5339 6.91348 6.03887 7.25957 6.34395L10.8399 9.5L7.25957 12.6561C6.91348 12.9611 6.91348 13.4661 7.25957 13.7712C7.60567 14.0763 8.17852 14.0763 8.52461 13.7712L12.7374 10.0576C12.9165 9.89977 13 9.69988 13 9.5Z",
    fill: "#949DA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardIcon);
export default __webpack_public_path__ + "static/media/arrow-forward-icon.827f2c593212964290fcabe82863eefb.svg";
export { ForwardRef as ReactComponent };